<div class="container">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'map.sidebar.psa.attach_event_modal.title' | translate }}</h5>
  </div>

  <div class="modal-body">
    <mat-form-field appearance="outline" class="w-100 mt-4">
      <input
        #myInput
        type="text"
        placeholder="{{ 'map.sidebar.psa.mitigating_action.search_placeholder' | translate }}"
        matInput
        (input)="onInput()"
        [(ngModel)]="searchTerm"
        [ngModelOptions]="{ standalone: true }"
        [matAutocomplete]="auto"
      />

      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="onOptionSelected($event.option.value)"
      >
        <mat-option *ngFor="let evento of listEventsFiltered" [value]="evento">
          {{ evento.nome }} - {{ evento.tipologia }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-error *ngIf="!listEventsFiltered.length" class="font-08rem mb-5"
      >Nessun evento da poter associare a questo elemento</mat-error
    >

    <div *ngFor="let eventoAssociato of associatedEvents" class="box-container my-1">
      <div class="d-flex align-items-center justify-content-start gap-1">
        <mat-icon (click)="onRemoveEvent(eventoAssociato)">{{ eventoAssociato?.old ? '' : 'delete' }}</mat-icon>
        <div>{{ eventoAssociato.nome }} - {{ eventoAssociato.tipologia }}</div>
      </div>

      <div class="d-flex align-items-center gap-1">
        <mat-icon svgIcon="probabilita" [matTooltip]="'Probabilità'"></mat-icon>
        <app-rank-selector
          [isDisabled]="eventoAssociato.old"
          [valueRank]="eventoAssociato.probabilita"
          [allowEmpty]="true"
          (rankChange)="onRankChange(eventoAssociato, $event)"
        ></app-rank-selector>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <button mat-raised-button color="primary" type="button" class="btn btn-secondary" (click)="createNewEvent()">
          {{ 'map.sidebar.psa.attach_event_modal.create' | translate }}
        </button>
        <span>
          {{ 'map.sidebar.psa.attach_event_modal.create_label' | translate }}
        </span>
      </div>
      <div class="col-6 text-end">
        <button mat-button type="button" (click)="onClose()">
          {{ 'map.sidebar.psa.attach_action_modal.button_cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" type="button" [disabled]="!isAnyEventSelected()" (click)="onSave()">
          {{ 'map.sidebar.psa.attach_event_modal.button_save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
